"use client"; // This is required for Next.js 14 to handle client-side form events

import { useState } from "react";
import  "./ReservationForm.scss";

const ReservationForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    date: "",
    guests: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission, e.g., send data to an API
    console.log(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="reservation-form">
      <div className="form-group">
        <label htmlFor="name">YOUR NAME*</label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Name here"
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="email">YOUR EMAIL*</label>
        <input
          type="email"
          id="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Email here"
          required
        />
      </div>

      <div className="form-group">
        <label htmlFor="phone">CONTACT NUMBER</label>
        <input
          type="tel"
          id="phone"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          placeholder="Phone number here"
        />
      </div>

   
      <div className="row">

      <div className="form-group col-md-6">
        <label htmlFor="date">DATE*</label>
        <input
          type="date"
          id="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-group col-md-6">
        <label htmlFor="guests">TOTAL GUESTS*</label>
        <select
          id="guests"
          name="guests"
          value={formData.guests}
          onChange={handleChange}
          required
        >
          <option value="" disabled>
            Select how many guests here
          </option>
          {[...Array(10).keys()].map((n) => (
            <option key={n + 1} value={n + 1}>
              {n + 1}
            </option>
          ))}
        </select>
      </div>
      </div>



      <div className="form-group">
        <label htmlFor="message">SPECIAL INFORMATION</label>
        <textarea
          id="message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          placeholder="Enter your message here"
        />
      </div>

      <button type="submit" className="submit-button">
        MAKE A RESERVATION
      </button>
    </form>
  );
};

export default ReservationForm;
